import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { EonUiButton, EonUiIcon, EonUiPreloaderCircle } from '@eon-ui/eon-ui-components-angular';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { TimerControlService } from '../../../service/timer-control.service';
import { UserService } from '../../../service/user.service';
import { TypewriterTextComponent } from '../../../component/typewriter-text/typewriter-text.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterService } from '../../../service/router.service';
import { Route } from '../../../enum/route.enum';
import { GameThemeService } from '../../../service/game-theme.service';
import { Game } from '../../../enum/game.enum';

export interface LevelStartDialogData {
  level: number;
}

@Component({
  selector: 'gandalf-level-start-dialog',
  imports: [
    EonUiButton,
    MatDialogActions,
    MatDialogContent,
    EonUiPreloaderCircle,
    TypewriterTextComponent,
    TranslatePipe,
    EonUiIcon,
  ],
  templateUrl: './level-start-dialog.component.html',
  styleUrl: './level-start-dialog.component.scss',
})
export class LevelStartDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<LevelStartDialogComponent>>(MatDialogRef);
  dialogData = inject<LevelStartDialogData | null>(MAT_DIALOG_DATA);
  protected readonly userService = inject(UserService);
  private readonly routerService = inject(RouterService);
  private readonly timerControl = inject(TimerControlService);
  private dialogLoading = signal(true);
  private missionTypewriterCompleted = signal(false);
  public isLoading = computed(() => this.dialogLoading());
  public canStartPrompting = computed(() => this.userService.userLevel() !== 1 || this.missionTypewriterCompleted());
  private readonly gameThemeService = inject(GameThemeService);
  protected readonly showCloseButton = this.gameThemeService.getCurrentGame() !== Game.GANDALF && (this.dialogData?.level ?? 0) <= 0;
  protected readonly eonUiScheme = this.gameThemeService.getEonUiScheme();

  ngOnInit() {
    // If dialog data contains a level, use it (prevents race conditions during level transitions)
    // Otherwise fetch from backend (e.g., on initial app load)
    if (this.dialogData?.level) {
      this.userService.userLevel.set(this.dialogData.level);
    } else {
      this.userService.getUserLevel();
    }

    setTimeout(() => {
      this.dialogLoading.set(false);
    }, 300);
  }

  navigateToGame() {
    if (!this.canStartPrompting()) {
      return;
    }

    this.routerService.navigateTo(Route.GAME);
    this.dialogRef.close(true);
    this.timerControl.startCountdown();
  }

  onMissionFinished(): void {
    this.missionTypewriterCompleted.set(true);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
